export default "__VITE_ASSET__q7AyNF7I__"